import { gql } from 'apollo-boost';
import ErrorsShower from 'core/components/common/ErrorsShower';
import NotFound from 'core/components/common/NotFound';
import { useIdsFromUrlWithoutParse } from 'core/hooks/useIdsFromUrl';
import { container, title } from 'core/style';
import injectSheet, { createStyles } from 'core/style/injectSheet';
import { ITheme, WithStyles } from 'core/style/interfaces';
import React from 'react';
import { useGetPageQuery } from 'site/graphql';

gql`
    query GetPage($slug: String!) {
        pageBySlug(slug: $slug) {
            id
            slug
            title
            content
        }
    }
`;

const Page: React.FC<WithStyles<typeof styles>> = ({ classes }) => {
    const { slug } = useIdsFromUrlWithoutParse('slug');
    const { data, loading, error } = useGetPageQuery({
        variables: { slug },
        fetchPolicy: 'network-only',
    });
    const page = data && data.pageBySlug;

    // @see \src\site\components\product\public\productDetailFetchData.tsx
    if (!loading && !page) {
        return <NotFound />;
    }

    return (
        <ErrorsShower error={error} loading={loading}>
            {page && (
                <div className={classes.root}>
                    <h1 className={classes.title}>{page.title}</h1>
                    <div className={classes.content} dangerouslySetInnerHTML={{ __html: page.content }} />
                </div>
            )}
        </ErrorsShower>
    );
};

const styles = (theme: ITheme) =>
    createStyles({
        root: {
            ...container(theme),
        },
        title: {
            ...title({ size: 'h1' }),
            marginTop: '1.5rem',
            textAlign: 'center',
        },
        content: {
            display: 'block',
            // костыли для поддержки старой верстки в статьях
            '& *': {
                'box-sizing': 'border-box',
            },
            '& img': {
                display: 'inline-block',
                'vertical-align': 'middle',
                'max-width': '100%',
                height: 'auto',
                '-ms-interpolation-mode': 'bicubic',
            },
            '& .block': {
                overflow: 'hidden',
            },
        },
    });

export default injectSheet(styles)(Page);
